// theme/adminTealTokens.js
// The Admin shell (AdminLayout's Sidebar/Header) now uses the SAME Jaipuria
// maroon/gold brand as the Manager/portal shell -- see theme/portalTokens.css
// for the CSS-variable source of truth. This JS mirror exists only because
// MUI `sx`/`alpha()` needs real color strings rather than `var(--*)`
// references; every value below is copied from portalTokens.css.
//
// The export keeps its historical name (ADMIN_TEAL) and key names so existing
// importers keep working unchanged -- only the values were repainted.
export const ADMIN_TEAL = {
  sidebarBg: "#4A0E22",
  sidebarBgDeep: "#4A0E22",
  sidebarHover: "#5C1830",
  sidebarActive: "#C89A3F",
  sidebarBorder: "#7A2340",

  topbarBg: "#FAF7F1",
  primary: "#6D1530",
  primaryHover: "#4A0E22",
  primaryActive: "#3A0B1B",
  primarySoft: "#FBEEF1",

  pageBg: "#FAF7F1",
  cardBg: "#FFFFFF",
  cardBorder: "#E7DED0",
  divider: "#E7DED0",

  heading: "#241F1A",
  text: "#6B6259",
  mutedText: "#8B877F",

  success: "#16A34A",
  successSoft: "#F0FDF4",
  danger: "#DC2626",
  dangerSoft: "#FEF2F2",
  warning: "#D97706",
  warningSoft: "#FFFBEB",
  info: "#2563EB",
  infoSoft: "#EFF6FF",

  textOnDark: "#F7F0E6",
};
